<div class="opleiding-card">
  <div class="opleiding-card__type-label" #label>
    {{ opleiding.soort }}
  </div>
  <a
    *ngIf="mode === 'DEFAULT'"
    title="{{ opleiding.naam }}"
    routerLink="/opleiding/{{ opleiding.slug }}"
  >
    <h3 class="opleiding-card__title">{{ opleiding.naam }}</h3>
  </a>
  <a
    *ngIf="mode === 'SELECTOR'"
    title="{{ opleiding.naam }}"
    (click)="handlePreviewClick()"
  >
    <h3 class="opleiding-card__title">{{ opleiding.naam }}</h3>
  </a>

  <div class="opleiding-card__content">
    <div class="opleiding-card__description">
      <p>{{ opleiding.omschrijving }}</p>
    </div>

    <div class="opleiding-card__bullits">
      <div class="opleiding-card__properties">
        <div class="opleiding-card__bullits-item" *ngIf="showMatchPercentage">
          <mat-icon>check_circle</mat-icon>
          <span class="opleiding-card__bullit-item--bold"
            >Matched {{ opleiding.matchPercentage }}%</span
          >
        </div>
        <div class="opleiding-card__bullits-item">
          <mat-icon>watch_later</mat-icon>
          <span class="opleiding-card__bullit-item--bold">{{
            opleiding.duur
          }}</span>
        </div>
        <div class="opleiding-card__bullits-item">
          <mat-icon>school</mat-icon>
          <span class="opleiding-card__bullit-item--bold">{{
            opleidingsniveaus
          }}</span>
        </div>
        <div class="opleiding-card__bullits-item">
          <mat-icon>location_city</mat-icon>
          <span class="opleiding-card__bullit-item--bold">{{
            opleiding.aanbieder
          }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="opleiding-card__actions" *ngIf="mode !== 'NONE'">
    <mat-divider></mat-divider>
    <app-button
      *ngIf="mode === 'SELECTOR'"
      mode="tertiary"
      data-cy="CardSelecteerOpleidingLink"
      (clicked)="handleSelect()"
      [rounded]="false"
    >
      {{ "opleiding-card.selectorButtonLabel" | content }}
    </app-button>
    <div class="opleiding-card__action--container" *ngIf="mode === 'DEFAULT'">
      <div
        class="opleiding-card__action--favorite"
        [ngClass]="{
          'favorite-delete': opleiding.favoriet,
          'favorite-add': !opleiding.favoriet
        }"
        (click)="handleFavoriteClick()"
      >
        <mat-icon>{{
          opleiding.favoriet ? "favorite" : "favorite_border"
        }}</mat-icon>
        <span *ngIf="opleiding.favoriet">
          {{ "opleiding-card.deleteCheckBoxLabel" | content }}
        </span>
        <span *ngIf="!opleiding.favoriet">
          {{ "opleiding-card.saveCheckBoxLabel" | content }}
        </span>
      </div>
    </div>
  </div>
</div>
